module.exports = __webpack_public_path__ + "static/media/13.e0bd4142.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/13.png
// module id = 865
// module chunks = 0